import AllApis from "app/Apis/apis";
import { MARKET_EXECUTIVE_COMMISSION_COMPANY_FAILED, MARKET_EXECUTIVE_COMMISSION_COMPANY_REQUEST, MARKET_EXECUTIVE_COMMISSION_COMPANY_SUCCESS } from "app/utils/constants/MarketExecutiveCompany";
import { Axios } from "index";


export const getMarketExecutiveCommissionCompanyList = ({ page = 1, sort = "desc", sortBy = "created_at", search_value = "", filters = {}, metId }) => {
    return async (dispatch) => {
        const payload = {
            searchFields: {
                string: [
                    "current_data.companyType",
                    "retailers.current_data.company_name",
                    "offlinestores.current_data.company_name",
                ],
                numbers:[
                    "current_data.commissionPercentage"
                ]
            }
        }

        if (!search_value) {
            search_value = "";
          }
      
          const urlParams = new URLSearchParams({
            search: search_value.trim(),
            page: page,
            sort: sort,
            sortBy: sortBy,
          });

        try {
            dispatch({ type: MARKET_EXECUTIVE_COMMISSION_COMPANY_REQUEST });
            const { data } = await Axios.post(`${AllApis.store.mtStore}?${urlParams.toString()}`,{...payload});
            dispatch({
                type: MARKET_EXECUTIVE_COMMISSION_COMPANY_SUCCESS, payload: {
                    marketExecutiveCommissionCompanyList: data?.data?.MarketExectiveCompany,
                    totalPage:data?.totalPage
                }
            })
        } catch (error) {
            dispatch({ type: MARKET_EXECUTIVE_COMMISSION_COMPANY_FAILED, payload: error?.response?.data?.message })
        }
    }
}